import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Modal.css';
import { withOnOutsideClick, testable } from '@xingternal/malt-util';
import { QA_MALT } from '@xingternal/malt-constants';

const TestableDiv = testable(QA_MALT, 'div');

function stopPropagation(event) {
  event.stopPropagation();
}

/**
 * Base container component to display overlay content
 */
function Modal({
  className,
  children,
  inContainer,
  top,
  left,
  shadow,
  testId,
}) {
  return (
    <TestableDiv
      onClick={stopPropagation}
      className={classNames(
        styles.base,
        {
          [styles.shadow]: shadow,
          [styles.inContainer]: inContainer,
          [styles.top]: inContainer && top,
          [styles.left]: inContainer && left,
        },
        className
      )}
      testId={testId}
    >
      {children}
    </TestableDiv>
  );
}

Modal.displayName = 'Modal';

Modal.defaultProps = {
  shadow: true,
  top: false,
  left: false,
};

Modal.propTypes = {
  /** Add a custom className to the modal */
  className: PropTypes.string,
  /** Contents of the modal */
  children: PropTypes.node.isRequired,
  /**
   * If given, this will be called whenever the user
   * clicks on something outside of the modal.
   */
  onOutsideClick: PropTypes.func,
  /**
   * Make the modal appear above the related content.
   * This does only work when in a `<ModalContainer />`
   */
  top: PropTypes.bool,
  /**
   * Make the modal extend to the left of the related content.
   * This does only work when in a `<ModalContainer />`
   */
  left: PropTypes.bool,
  /** If the modal should be displayed with a shadow */
  shadow: PropTypes.bool,
  /**
   * @private
   * <ModalContainer /> will set this prop to enable alignment styling
   */
  inContainer: PropTypes.bool,
  /** define a testid for the modal */
  testId: PropTypes.string,
};

const ModalWithOnOutsideClick = withOnOutsideClick(Modal);

ModalWithOnOutsideClick.displayName = Modal.displayName;

export default ModalWithOnOutsideClick;
